export namespace ApiEnums {
  export enum AlertType {
    Unknown = 0,
    MixedLightHeavyWeights,
    MixedZeroHeavyWeights,
    WeightOverridden,
  }

  export enum AlertStatus {
    Unknown = 0,
    Opened,
    Closed,
  }

  export enum AlertCategory {
    Unknown = 0,
    Weights,
  }

  export enum AlertCommand {
    ApplyRecommended = -1,
    UpdateWeightRecord = 0,
    CleanWeightRecord,
    SetWeightRecordToDefault,
    SetWeightThreshold,
    CloseAlert,
  }

  export enum Source {
    Unknown = 0,
    System,
    Operator,
    Support,
    Other,
  }

  export enum ProblemType {
    Unknown = 0,
    Hardware,
    Software,
    Other,
  }

  export enum IncidentPriority {
    None = 0,
    Low,
    Medium,
    High,
    Critical,
  }

  export enum OperatorAction {
    None = 0,
    CallForSupport,
    ValidateIssueResolved,
  }

  export enum CommandStatus {
    None = 0,
    New,
    InProgress,
    Completed,
    CompletedWithErrors,
    Failed,
    Canceled,
    Pending,
  }

  export enum ScheduledCommandStatus {
    None = 0,
    Pending,
    ExecutionInProgress,
    ExecutionCompleted,
    ExecutionCompletedWithErrors,
    ExecutionFailed,
    Completed,
    CompletedWithErrors,
    Failed,
    Canceled,
  }

  export enum WeightCategory {
    Mixed = 0,
    Light,
    Medium,
    Heavy,
  }

  export enum IncidentStatus {
    Unknown = 0,
    Open,
    InProgress,
    Resolved,
    Closed,
  }

  export enum TicketCommand {
    CloseTicket,
    ResetDevice,
    Reboot,
  }

  export enum DeviceStatus {
    Unknown = 0,
    Ok,
    Inconvenienced,
    Error,
  }

  export enum NodeAvailabilityStatus {
    Unknown = 0,
    Operational,
    NotOperational,
  }

  export enum ManagementActions {
    None = 0,
    InitialRegistration,
    Active,
    TransferPending,
    TransferCompleted,
    TransferCancelled,
    Decommissioned,
    Reactivated,
    ReimagePending,
    ReimageCancelled,
    ReimageCompleted,
    RegistrationSuccessfull,
    UnScheduledChange,
  }

  export enum NodeReportingStatus {
    Unknown = 0,
    Reporting,
    NotReporting,
  }

  export enum Widgets {
    AssetsSummary = 1,
    DeviceStatusSummary,
    HealthSummary,
    AlertsSummary,
    TicketsSummary,
  }

  export enum DateRangeOptions {
    Today = 0,
    Yesterday,
    LastSevenDays,
    LastThirtyDays,
    Other,
  }

  export enum PreventiveMaintenanceStatus {
    Unknown = 0,
    Open,
    TechDispatchRequested,
    TechDispatched,
    DoneByTechEnterprise,
    DoneByTechDP,
    DoneAutomatically,
  }

  export enum PredictiveMaintenanceStatus {
    Unknown = 0,
    Open,
    TechDispatchRequested,
    TechDispatched,
    DoneByTechEnterprise,
    DoneByTechDP,
    DoneAutomatically,
  }

  export enum NotificationFrequency {
    Unknown = 0,
    Immediate,
    Daily,
    Weekly,
    Monthly,
  }

  export enum NotificationStatus {
    None = 0,
    Pending,
    Sent,
    Failed,
  }

  export enum MaintenanceType {
    Unknown = 0,
    Preventive,
    Predictive,
  }

  export enum DaysOfWeek {
    Sunday = 0,
    Monday,
    Tuesday,
    Wednesday,
    Thursday,
    Friday,
    Saturday,
  }

  export enum ConfigSettingsType {
    RegistrySetting = 0,
    JsonSetting,
  }

  export enum FileUploadStatus {
    Uploading = 0,
    Completed,
    Failed,
  }

  export enum FileValidationState {
    Idle = 0,
    Validating,
    Failed,
  }

  export enum ProductDeploymentStatus {
    Unknown = 0,
    Healthy,
    Error,
  }
}
